"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _core = require("../core");

var _utils = require("../utils");

var useStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    disabled: {},
    // Needed for referencing.
    focusVisible: {},
    // Needed for referencing.
    root: {
      height: '2.25rem',
      paddingLeft: "".concat(theme.spacing(3), "px"),
      paddingRight: "".concat(theme.spacing(3), "px"),
      '&$disabled': {
        color: theme.palette.text.disabled,
        backgroundColor: theme.palette.grey[100]
      }
    },
    rounded: {
      borderRadius: 999
    },
    sizeLarge: {
      fontSize: '1.25rem'
    },
    sizeSmall: {
      paddingLeft: "".concat(theme.spacing(0.75), "px"),
      paddingRight: "".concat(theme.spacing(0.75), "px"),
      minWidth: 'unset'
    },
    contained: {
      '&:hover': {
        '@media (hover: none)': {
          backgroundColor: 'transparent',
          boxShadow: theme.shadows[2]
        }
      }
    },
    containedPrimary: {
      '&:hover': {
        backgroundColor: (0, _utils.hexMixColor)(theme.palette.primary.main, '#000000', 0.04),
        // Primary main 4% darker
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$focusVisible': {
        backgroundColor: (0, _utils.hexMixColor)(theme.palette.primary.main, '#000000', 0.12) // Primary main 12% darker

      }
    },
    containedSecondary: {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.grey[50],
      '&:hover': {
        backgroundColor: (0, _utils.hexMixColor)(theme.palette.grey[50], '#000000', 0.04),
        // Primary main 4% darker
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[50]
        }
      },
      '&$focusVisible': {
        backgroundColor: (0, _utils.hexMixColor)(theme.palette.grey[50], '#000000', 0.12) // Primary main 12% darker

      },
      '&$sizeSmall': {
        // Special case for Icon Only
        color: theme.palette.text.secondary
      }
    },
    outlinedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      border: 0,
      '&:hover': {
        border: 0,
        backgroundColor: (0, _utils.hexMixColor)(theme.palette.primary.main, '#000000', 0.04),
        // Primary main 4% darker
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main,
          boxShadow: theme.shadows[0]
        }
      },
      '&$disabled': {
        border: 0
      },
      '&$focusVisible': {
        backgroundColor: (0, _utils.hexMixColor)(theme.palette.primary.main, '#000000', 0.12) // Primary main 12% darker

      }
    },
    outlinedSecondary: {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.grey[50],
      borderColor: theme.palette.grey['400'],
      '&:hover': {
        backgroundColor: (0, _utils.hexMixColor)(theme.palette.grey[50], '#000000', 0.04),
        // Primary main 4% darker
        borderColor: theme.palette.grey['400'],
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[50]
        }
      },
      '&$focusVisible': {
        backgroundColor: (0, _utils.hexMixColor)(theme.palette.grey[50], '#000000', 0.12) // Primary main 12% darker

      }
    },
    textPrimary: {
      '&:hover': {
        backgroundColor: (0, _utils.hexToRgbaString)(theme.palette.primary.main, 0.04) // Primary main at 4% opacity

      },
      '&$focusVisible': {
        backgroundColor: (0, _utils.hexToRgbaString)(theme.palette.primary.main, 0.12) // Primary main at 12% opacity

      }
    },
    textSecondary: {
      color: theme.palette.text.secondary,
      '&:hover': {
        backgroundColor: (0, _utils.hexToRgbaString)(theme.palette.text.secondary, 0.04) // Text secondary at 4% opacity

      },
      '&$focusVisible': {
        backgroundColor: (0, _utils.hexToRgbaString)(theme.palette.text.secondary, 0.12) // Text secondary at 12% opacity

      }
    }
  };
}, {
  name: (0, _core.rochePrefix)('Button')
});
exports.useStyles = useStyles;